export default "__VITE_ASSET__Cj67AEk0__"